import { HotSpot } from './hotSpot';

export class PanoramaImages {
    id: number
    image: String
    mobile: boolean
    siteId: number
    panoramaHotSpots: HotSpot[] = [];
    base64: String;
    forDeletion:boolean;
    rotateX: number;
    rotateY: number;
    northRotateY:number;
    latitude:number;
    longitude:number;
    natural:boolean;

    constructor() {
        this.id = Date.now();
    }
}